/**
 * src/api/clientes.js
 * Funciones puras para el CRUD de clientes (admin).
 * Cada función retorna los datos directamente (sin el envelope de axios).
 */
import api from './client'

export const getClientes = (soloActivos = true) =>
  api.get('/admin/clientes', { params: { solo_activos: soloActivos } }).then(r => r.data)

export const getCliente = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}`).then(r => r.data)

export const getUso = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}/uso`).then(r => r.data)

export const createCliente = (data) =>
  api.post('/admin/clientes', data).then(r => r.data)

export const updateCliente = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}`, data).then(r => r.data)

export const deleteCliente = (clienteId) =>
  api.delete(`/admin/clientes/${clienteId}`)

export const addCompetidor = (clienteId, data) =>
  api.post(`/admin/clientes/${clienteId}/competidores`, data).then(r => r.data)

export const updateCompetidor = (clienteId, compId, data) =>
  api.put(`/admin/clientes/${clienteId}/competidores/${compId}`, data).then(r => r.data)

export const updateEmpresa = (clienteId, empId, data) =>
  api.put(`/admin/clientes/${clienteId}/empresas/${empId}`, data).then(r => r.data)

export const updateScheduler = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/scheduler`, data).then(r => r.data)

export const updateTierOverride = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/tier-override`, data).then(r => r.data)

export const updateEstado = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/estado`, data).then(r => r.data)

export const cancelarSuscripcion = (clienteId) =>
  api.post(`/admin/clientes/${clienteId}/cancelar-suscripcion`).then(r => r.data)
